export default function AuthValidatePage() {
	return (
		<main className="h-screen flex items-center justify-center overflow-auto p-8 bg-[#fafafa]">
			<div className="max-w-[960px] mx-auto">
				<p>Authenticating...</p>
			</div>
		</main>
	);
}
